import {useProductDetails} from "../../store/productDetails";
import {ProductCard, ProductCardSkeleton} from "../common/ProductCard";

export const ProductRecommendations = () => {
    const {
        recs,
        recsLoading,
        recsError,
    } = useProductDetails();

    return (
        <div className="mt-16 mb-16">
            <h2 className="text-2xl font-bold text-base-content mb-8">Related Products</h2>

            {recsLoading && !recsError ? (
                <div className="flex gap-6 overflow-hidden">
                    {[1, 2, 3, 4, 5].map(i => <ProductCardSkeleton key={i}/>)}
                </div>
            ) : (
                (recs.alsoBought?.length > 0 || recs.alsoViewed?.length > 0) ? (
                    <div className="flex overflow-x-auto flex-nowrap gap-6 pb-8 no-scrollbar scroll-smooth">
                        {[...recs.alsoBought, ...recs.alsoViewed].slice(0, 12).map((p) => (
                            <div key={p.sku} className="w-64 shrink-0">
                                <ProductCard product={p}/>
                            </div>
                        ))}
                    </div>
                ) : (
                    !recsLoading && (
                        <div className="alert alert-info bg-info/10 border-info/20 rounded-xl">
                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                                 className="stroke-info shrink-0 w-6 h-6">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2"
                                      d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></path>
                            </svg>
                            <span className="text-sm font-medium">No recommendations available for this item.</span>
                        </div>
                    )
                )
            )}
        </div>
    );
};
